export default {
	"Card.Online": "上線",
	"Card.Hot": "火爆",
	"Card.SoldOutSoon": "即將售罄",
	"Card.SnappingUp": "搶購中",
	"Card.OffTheEnd": "離結束",
	"Card.ComingSoon": "即將開始",
	"Card.sky": "天",
	"Card.Sold": "已售",
	"Card.SnapItUpNow": "立即搶購",
	"Card.MarketingMallComponentClick": "行銷商城_元件點擊",
	"Card.MarketingMarketplace": "行銷商城",
	"Card.AListOfStoreItems": "店鋪商品清單",
	"Card.StoreResourceBits": "店鋪資源位",
	"Card.More": "更多>"
}